import React, {useState, useEffect} from 'react'
import './taginput.css';
import { styled } from 'styled-components';

function TagInput(props) {
    const [value, setvalue]     = useState('');
    const [tagList, settagList] = useState([]);
    const [loading, setloading] = useState(true);
    const id = props.id ? props.id : 'taginput';

    useEffect(() => {
        if(loading){
            //if loading value
            if(props.defaultValue){
                //set default value
                if(typeof props.defaultValue === 'string' && props.defaultValue.length > 0){
                    let arrayValue  = props.defaultValue.split(',');
                    let newValues   = [];

                    //console.log('values', arrayValue);
                    arrayValue.map((item) => {
                        if(item !== ''){
                            newValues.push(item);
                        }
                    });

                    settagList(newValues);
                    setloading(false);

                    if(props.onChange){
                        let listString = newValues.length > 0 ? ','+newValues.toString()+',' : '';
                        props.onChange(listString);
                    }
                }
            }
        }
    }, [props.defaultValue, loading]);

    // Requerimiento: el campo solo debe permitir caracteres alfanuméricos (incluye tildes/ñ propias del español)
    const REGEX_CARACTER_VALIDO = /^[a-zA-Z0-9À-ÿÑñ]$/;

    const changeTextInput = (e) => {
        const {value} = e.target;
        console.log(value.trim());

        if ( e.key === 'Enter' || e.keyCode === 13 || e.code == "Space" || e.keyCode == 32  ) {
            e.preventDefault();

            let trimValue = value.trim();
            if(trimValue !== ""){
                if(tagList.includes(trimValue)){
                    // no add becouse
                }else{
                    //add
                    let newTagList = [...tagList];
                    newTagList.push(trimValue);

                    settagList(newTagList);
                    if(props.onChange){
                        let listString = newTagList.length > 0 ? ','+newTagList.toString()+',' : '';
                        props.onChange(listString);
                    }
                    document.getElementById(id).value = "";
                }
            }
        }else if(e.keyCode == 8 || e.keyCode == 46 ){
            let trimValue = value.trim();
            if(trimValue !== ""){
                // borra
                return;
            }else{
                console.log('delete element');
                e.preventDefault();
                let newTagList = [...tagList];

                if(newTagList.length > 0){
                    let deleteLastElement = newTagList.pop();
                    settagList(newTagList);
                    if(props.onChange){
                        let listString = newTagList.length > 0 ? ','+newTagList.toString()+',' : '';
                        props.onChange(listString);
                    }
                }
            }
        }else{
            // Bloquear caracteres no alfanuméricos: si es una tecla de un solo carácter (imprimible) y no matchea el regex, se descarta.
            // Teclas de control (Shift, CapsLock, F1, ArrowLeft, etc.) tienen e.key.length > 1 y no se ven afectadas.
            if (e.key.length === 1 && !REGEX_CARACTER_VALIDO.test(e.key)) {
                e.preventDefault();
                return;
            }
            setvalue(value);
        }
    }

    // Refuerzo del filtro de arriba: el onKeyDown no intercepta bien las teclas
    // muertas (^ ´ ¨ ~, típicas de teclados en español para componer acentos),
    // porque el navegador las procesa como una "composición" y dispara
    // e.key === "Dead" en vez del carácter imprimible normal — por eso
    // REGEX_CARACTER_VALIDO nunca las evalúa y se cuelan. Este handler corrige
    // el valor apenas cambia (se dispara al terminar la composición), sin
    // importar el origen: tecla muerta, IME, autocompletado, etc.
    const sanitizeInputValue = (e) => {
        const valorLimpio = e.target.value.replace(/[^a-zA-Z0-9À-ÿÑñ]/g, '');
        if (valorLimpio !== e.target.value) {
            e.target.value = valorLimpio;
        }
    }

    const deleteTag = (item) => {
        let newList = tagList.filter(tag => tag !== item);
        settagList(newList);

        if(props.onChange){
            let listString = newList.length > 0 ? ','+newList.toString()+',' : '';
            props.onChange(listString);
        }
    }

    // Al pegar texto (Ctrl+V), onKeyDown no se dispara por cada carácter, así que se filtra aparte.
    const handlePasteInput = (e) => {
        e.preventDefault();
        const textoPegado = (e.clipboardData || window.clipboardData).getData('text');
        const textoLimpio = textoPegado.replace(/[^a-zA-Z0-9À-ÿÑñ]/g, '');

        const input = e.target;
        const inicio = input.selectionStart;
        const fin = input.selectionEnd;
        const valorActual = input.value;

        input.value = valorActual.slice(0, inicio) + textoLimpio + valorActual.slice(fin);
        const nuevaPosicion = inicio + textoLimpio.length;
        input.setSelectionRange(nuevaPosicion, nuevaPosicion);
    }

    let vPlaceHolder= "this.props?.placeholder" ;

    return (
        <div>
            <div className='taginput-container'>
                <div className='taginput'>
                    {tagList.length > 0 && tagList.map((item, key) => {
                        return <span className='tag' key={key}>
                            <span className='tagname'>{item}</span>
                            <button 
                                type='button' 
                                onClick={() => deleteTag(item)} 
                                className='tagbtn'
                            >x</button>
                        </span>
                    })}
                    <input 
                        id={id}
                        type="text" 
                        defaultValue={value}
                        onKeyDown={(e) => changeTextInput(e)}
                        onInput={sanitizeInputValue}
                        onPaste={handlePasteInput}
                        placeholder={props.placeholder}
                        style={{width:'100%'}}
                    />
                </div>
            </div>
            {/* <p className='small-note'>
                Escriba y presione <strong>enter</strong> pasa agregar una palabra clave
            </p> */}
        </div>
    );
}

export default TagInput